<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex xs12>
      <Toggle
        v-model="agreement.visitor_agreement"
        title="Visitor Agreement"
        caption="Enable or disable agreement signing before the visitor entering workplace premises"
        @change="updateToggle"
      />
      <template v-if="agreement.visitor_agreement">
        <div class="title font-weight-bold py-3 mt-2 text-xs-center">
          Agreement Content
        </div>
        <vue-editor
          v-model="agreement.editor_content"
          :editor-options="editorOptions"
          @input="editorContentChanged"
        />
      </template>
    </v-flex>
  </v-layout>
</template>
<script>
import _cloneDeep from 'lodash/cloneDeep';
import Toggle from '@/components/common/Toggle';

import { VueEditor, Quill } from 'vue2-editor';

const alignClass = Quill.import('attributors/class/align');
const BackgroundClass = Quill.import('attributors/class/background');
const ColorClass = Quill.import('attributors/class/color');
const DirectionClass = Quill.import('attributors/class/direction');
const FontClass = Quill.import('attributors/class/font');
const SizeClass = Quill.import('attributors/class/size');

const alignStyle = Quill.import('attributors/style/align');
const BackgroundStyle = Quill.import('attributors/style/background');
const ColorStyle = Quill.import('attributors/style/color');
const DirectionStyle = Quill.import('attributors/style/direction');
const FontStyle = Quill.import('attributors/style/font');
const SizeStyle = Quill.import('attributors/style/size');

Quill.register(alignClass, true);
Quill.register(BackgroundClass, true);
Quill.register(ColorClass, true);
Quill.register(DirectionClass, true);
Quill.register(FontClass, true);
Quill.register(SizeClass, true);
Quill.register(alignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

export default {
  name: 'Agreement',
  components: {
    Toggle,
    VueEditor
  },
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      agreement: {},

      editorOptions: {
        modules: {
          toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, false] }],
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons

            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }]
          ]
        },
        theme: 'snow'
      }
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.agreement = _cloneDeep(val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.agreement, validation]);
  },
  methods: {
    updateToggle(val) {
      this.agreement.visitor_agreement = val;
    },
    editorContentChanged(val) {
      this.agreement.append_content.replace('{{editorContent}}', val);
      // Todo remove ql-cursor and apple-newline classes
    }
  }
};
</script>
<style>
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  height: calc(100vh - 404px);
  overflow-y: scroll;
}
</style>

